import Macy from 'macy';

const $ = window.jQuery;

/**
 * Enables masonry layouts.
 *
 */
const Masonry = {

    selector: '*[data-masonry]',    // selector to find masonry container elements
    configAtr: 'masonry',           // data attribute where config is (e.g.
                                    // `masonry` for `data-masonry`)
    defaultConfig: {                // default config for masonry instances
        mobileFirst: true,
    },

    /**
     * Initialise functionality
     */
    init()
    {

        let vm = this;

        // initialize instances
        $(vm.selector).each(function() {

            const $container = $(this);
            const config = $container.data(vm.configAtr) || {};

            const macy = Macy({
                ...{container: $container[0]},
                ...vm.defaultConfig,
                ...config,
            });

            // Allow triggering recalculating layouts
            // TODO - recalculate on any Alpine change
            $(window).on('mwb/component/masonry/refresh', () => {
                macy.recalculate(true);
            });

        });

    },

};

export default Masonry;